var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavIcon2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 16,
    width: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 0C3.58 0 0 3.58 0 8C0 11.54 2.29 14.43 5.47 15.54C5.87 15.61 6.03 15.36 6.03 15.15C6.03 14.97 6.02 14.36 6.02 13.65C4 14.09 3.48 12.91 3.48 12.91C3.12 12.1 2.63 11.9 2.63 11.9C1.92 11.45 2.67 11.46 2.67 11.46C3.44 11.52 3.83 12.25 3.83 12.25C4.51 13.4 5.68 13.04 6.13 12.82C6.2 12.33 6.4 12.01 6.63 11.84C4.83 11.65 2.93 10.95 2.93 7.84C2.93 6.95 3.26 6.25 3.77 5.71C3.68 5.49 3.39 4.64 3.85 3.48C3.85 3.48 4.5 3.3 6.01 4.41C6.65 4.24 7.35 4.16 8.05 4.16C8.75 4.16 9.45 4.24 10.09 4.41C11.6 3.3 12.25 3.48 12.25 3.48C12.71 4.64 12.42 5.49 12.33 5.71C12.84 6.25 13.17 6.95 13.17 7.84C13.17 10.95 11.27 11.64 9.47 11.83C9.75 12.04 10 12.48 10 13.15C10 14.12 9.99 14.94 9.99 15.15C9.99 15.36 10.15 15.62 10.56 15.54C13.71 14.43 16 11.54 16 8C16 3.58 12.42 0 8 0Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavIcon2);
export default __webpack_public_path__ + "static/media/nav-icon2.eba1275f279a7a34a0847361287ad7cc.svg";
export { ForwardRef as ReactComponent };